import { useState, type FormEvent } from "react";
import { Navigate, useSearchParams } from "react-router";
import { api, ApiError, errorMessage, unwrap } from "../../api/client";
import { useSession } from "../../auth/session";
import { fr } from "../../i18n/fr";
import { Field, Logo } from "../../ui/components";

export function LoginPage() {
  const s = useSession();
  const [params] = useSearchParams();
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const next = params.get("next") ?? "/";

  if (s.me) return <Navigate to={next.startsWith("/") ? next : "/"} replace />;

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      const me = unwrap(await api.POST("/auth/login", { body: { login: login.trim(), password } }));
      s.setMe(me);
    } catch (x) {
      setError(x instanceof ApiError ? (fr.login as Record<string, string>)[x.code] ?? errorMessage(x, fr.errors) : errorMessage(x, fr.errors));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page narrow">
      <div className="card login">
        <div className="public-brand"><Logo size={40} /><h1>{fr.login.title}</h1></div>
        <p className="muted small">{fr.login.intro}</p>
        <form onSubmit={submit} className="stack">
          <Field label={fr.login.login}><input autoFocus autoComplete="username" value={login} onChange={(e) => setLogin(e.target.value)} required /></Field>
          <Field label={fr.login.password}><input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required /></Field>
          {error && <div className="error">{error}</div>}
          <button className="primary" type="submit" disabled={busy || !login || !password}>{busy ? fr.login.busy : fr.login.submit}</button>
          <p className="muted small">{fr.login.sessionInfo}</p>
        </form>
      </div>
    </div>
  );
}
